import { Component, h, Host, JSX, Prop } from '@stencil/core';
import { injectHistory, RouterHistory } from '@stencil/router';
import { store } from '../../utils/store';
import { CountriesEnum, LocalesEnum, RegionsEnum } from '../../generated/operations';
import { UserSettings } from '../../types/UserSettings';
import { USER_SETTINGS } from '../constants';
import { debounce } from 'src/utils/debounce';
import { getCountryData } from 'src/utils/parseSettingsFromUrl';

@Component({
  tag: 'app-country-selector',
  shadow: false,
})
export class AppCountrySelector {
  @Prop({ mutable: true }) history: RouterHistory;

  private handleClick!: (region: RegionsEnum, code: CountriesEnum, locale: LocalesEnum) => Promise<void>;


  public async componentWillLoad(): Promise<void> {
    const chooseCountry = (region: RegionsEnum, code: CountriesEnum, locale: LocalesEnum): void => {
      store.state.isRegionDetected = false;
      store.state.oldState = {
        config: store.state.config,
        settings: {
          shoppingCenter: store.state.shoppingCenter,
          currentCountry: store.state.currentCountry,
          currentLocale: store.state.currentLocale,
          currentRegion: store.state.currentRegion,
        }
      }
      const { data } = getCountryData(code, store.state.config);
      const userSettings: UserSettings = {
        shoppingCenter: data.shoppingCenter || null,
        currentLocale: locale,
        currentRegion: region,
        currentCountry: code,
      };
      const storage = store.get('offlineStorage');
      storage.set(USER_SETTINGS, JSON.stringify(userSettings));
      const isRegionChanged = userSettings.currentRegion !== store.state.currentRegion;
      const isCountryChanged = userSettings.currentCountry !== store.state.currentCountry;
      store.state.currentCountry = userSettings.currentCountry;
      store.state.currentLocale = userSettings.currentLocale;
      store.state.currentRegion = userSettings.currentRegion;
      store.state.shoppingCenter = userSettings.shoppingCenter;
      store.state.currentLocaleAndRegion = {
        locale: store.state.currentLocale,
        region: store.state.currentRegion,
      }
      if (isRegionChanged || isCountryChanged) {
          this.history.push('/');
      }
    }
    this.handleClick = debounce<typeof chooseCountry>(chooseCountry, 300);
  }

  public render(): JSX.Element {
    if (store.state.config === null) {
      return '';
    }
    const { countries } = store.state.config;
    return (<Host>
      {[RegionsEnum.Eu, RegionsEnum.Am, RegionsEnum.Ap].map((region) => {
        const rows = countries.filter((item) => item.data.region === region);
        return (
          <div class="language-selector__column">
            <h3 class="language-selector__title">
              <belimo-i18n messageId={region}/>
            </h3>
            <ul>
              {rows.map((data) => {
                const [first] = data.data.locales;
                return (
                  <li class={{ 'language-selector__item--selected': store.state.currentCountry === data.code }}>
                    <a href={'#'} onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      this.handleClick(region, data.code, first.locale).then(() => null).catch((e) => console.warn(e));
                    }}>
                      {data.data.countryName}
                    </a>
                  </li>
                )
              })}
            </ul>
          </div>
        )
      })}
    </Host>)
  }
}

injectHistory(AppCountrySelector);
